.list {
  --_item-gap: var(--number-fields-gap, 24px);

  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  gap: 4px var(--_item-gap);
  font-size: 13px;
  color: var(--color-text-secondary);
}

.item {
  @container (width < 420px) {
    flex: 1 1 0px;
  }

  a,
  button,
  strong {
    display: block;
    font-weight: 600;
    color: var(--color-text-primary);
    font-size: 15px;
    white-space: nowrap;
  }

  a {
    padding: 0;
    text-decoration: none;
  }

  a,
  button {
    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }

  button {
    appearance: none;
    background: none;
    border: none;
    display: block;
    padding: 0;
  }
}
